var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDigitalPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/icon_digital_pen") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.2002 0.3006 12.8002 0.3006 12.8002 14 0.2002 14"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/icon_digital_pen",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 17.400000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2002,12.1996 C5.2002,11.8996 1.9002,11.0006 1.9002,7.3006 C1.9002,2.1996 7.9002,2.0996 8.2002,2.0996 L12.0002,2.0996 C12.2002,1.5006 12.5002,0.8996 12.8002,0.3006 L8.2002,0.3006 C5.4002,0.3006 0.2002,1.8006 0.2002,7.3006 C0.2002,12.5006 5.0002,13.6996 7.0002,13.8996 C7.4002,14.0006 8.4002,14.0006 8.9002,14.0006 C8.6002,13.5006 8.5002,12.8996 8.5002,12.1996 L7.2002,12.1996 Z",
    id: "Fill-1",
    fill: "#0078D7",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.7998,10.5 C27.0998,10.4 26.2998,10.4 25.4008,10.6 C25.4008,10.7 25.4008,10.8 25.2998,10.8 C24.9008,11.5 24.5998,12.2 24.2998,12.9 C25.4998,12.1 26.4998,12 27.4998,12.2 C27.4998,12.2 29.9008,12.6 29.9008,15 C29.9008,17.3 27.2998,17.7 27.2998,17.7 L21.9998,17.7 C21.7998,18.2 21.0998,19.5 21.0998,19.5 L27.4008,19.5 C28.4008,19.5 31.6998,18.4 31.6998,15 C31.6998,11.7 28.7998,10.6 27.7998,10.5",
    id: "Fill-4",
    fill: "#0078D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,4.7002 L14.7,25.4002 C14.6,25.5992 14.5,25.7002 14.3,25.7002 C14.1,25.8002 14,25.7002 13.8,25.7002 L13.2,25.4002 C12.9,25.2002 12.7,24.8002 12.9,24.5002 L23.2,3.8002 C23.4,3.5002 23.8,3.4002 24.1,3.5002 L24.7,3.8002 C25.1,4.0002 25.2,4.4002 25,4.7002 M11.4,29.5002 C11,29.2002 11.5,26.3002 12.1,26.3002 L12.2,26.3002 C12.3,26.3002 13.4,27.0002 13.4,27.0002 L13.5,27.0992 C13.8,27.7002 11.8,29.8002 11.4,29.5002 M26.3,3.1002 C26.1,2.9002 26.8,1.9002 26.5,1.7002 L25.2,1.0002 C25,0.9002 24.4,2.0002 24.1,1.9002 C23.5,1.8002 22.9,2.0002 22.4,2.4002 L21.1,1.6002 C20.9,1.5002 20.7,1.5002 20.5,1.5002 C20.3,1.6002 20.1,1.8002 20,2.0002 L14.8,11.9002 C14.6,12.3002 14.7,12.7002 15.1,12.9002 C15.5,13.1002 15.9,13.0002 16.1,12.6002 L21,3.4002 L21.6,3.8002 L11.5,23.8002 C11,24.9002 9.3,30.0992 10.3,30.5992 L10.8,30.8002 C12.4,31.5002 15.8,26.5002 16,26.0002 L26.4,5.4002 C26.7,4.7002 26.8,3.6002 26.3,3.1002",
    id: "Fill-6",
    fill: "#0078D7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDigitalPen);
export default __webpack_public_path__ + "static/media/icon_digital_pen.df9f5ec33dde0f8cd2bebbda50778b09.svg";
export { ForwardRef as ReactComponent };